export default __webpack_public_path__ + "3537acdade7f28802763849e64370d99.svg";